import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../src/index.css";
import "./NabiHealth.css";
import { useNavigate } from "react-router-dom";
import { db } from "./firebase";
import { collection, onSnapshot } from "firebase/firestore";
import "./Blogs.css";
// Asset placeholders (using generic icons or text where images aren't available)
const ASSETS = {
  logoGraphic: "/Nabi UI Assets/Assets_Images/Logo placeholder.png",
  icons: {
    arrowLeft: "/Nabi UI Assets/Assets_Icon/Icon_Double arrow left.svg",
    arrowRight: "/Nabi UI Assets/Assets_Icon/Icon_Double arrow right.svg",
    search: "/Nabi UI Assets/Assets_Icon/Icon_Search.svg"
  }
};

export default function NabiHealth({ onConnect }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [dynamicQuotes, setDynamicQuotes] = useState(() => {
    const cached = localStorage.getItem("nabi_cached_quotes");
    return cached ? JSON.parse(cached) : [];
  });
  const [isLoadingQuotes, setIsLoadingQuotes] = useState(() => {
    return !localStorage.getItem("nabi_cached_quotes");
  });
  const [activeCategory, setActiveCategory] = useState("All");
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribeQuotes = onSnapshot(collection(db, "dailyQuotes"), (querySnapshot) => {
      let fetched = querySnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          _time: data.createdAt?.toMillis ? data.createdAt.toMillis() : (data._time || 0)
        };
      });
      
      fetched.sort((a, b) => (b._time || 0) - (a._time || 0));
      
      setDynamicQuotes(fetched);
      setIsLoadingQuotes(false);
      localStorage.setItem("nabi_cached_quotes", JSON.stringify(fetched));
    }, (error) => {
      console.error("Error fetching daily quotes:", error);
      setIsLoadingQuotes(false);
    });

    return () => unsubscribeQuotes();
  }, []);

  useEffect(() => {
    const filtered = activeCategory === "All" ? dynamicQuotes : dynamicQuotes.filter(q => q.category === activeCategory);
    if (filtered.length <= 1) return;
    
    const id = setInterval(() => {
      setCurrentQuoteIndex((prev) => (prev + 1) % filtered.length);
    }, 6000);
    
    return () => clearInterval(id);
  }, [activeCategory, dynamicQuotes, currentQuoteIndex]);


  const slides = [

    {
      title: "What is Nabi?",
      text: "Nabi is a preventive and supportive emotional well-being space, built around reflection: understanding one's thoughts, feelings, and emotions a little better."
    },

    {
      title: "Nabi & Access.",
      text: "Nabi is designed to make psychological health and safety more accessible: meeting you where you are, whenever you choose to check in with yourself."
    }
  ];
  //     {
  //   title: "Why Nabi?",
  //   text: "Nabi is not here to tell you what to feel, but to hold up a mirror: giving you room to notice, name, and navigate your inner world at your own pace."
  // }, 

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const id = setInterval(nextSlide, 8000);
    return () => clearInterval(id);
  }, []);

  const handleConnect = () => {
    if (onConnect) {
      onConnect();
    } else {
      navigate("/therapist");
    }
  };

  return (
    <div className="nabi-health-container">


      {/* 2. CATEGORIZED QUOTES SECTION */}
      <section className="quotes-tab-section" style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '40px', marginTop: '20px' }}>
        <div style={{ width: '90%', maxWidth: '1200px', backgroundColor: '#FFF9F5', borderRadius: '30px', padding: '30px', boxSizing: 'border-box' }}>
          
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
             <div>
                {/* <h2 style={{ fontSize: '24px', color: '#333', margin: '0 0 5px 0', fontFamily: "'Syne', sans-serif" }}>Hey !</h2> */}
                <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>Here are few reminders to inspire, uplift, and brighten your day</p>
             </div>
             {/* <div style={{ backgroundColor: '#FFEBD9', padding: '10px 15px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold', color: '#D97757' }}>
                Quotes
             </div> */}
          </div>

          {/* Category Tabs */}
          <div className="pill-wrapper" style={{ marginBottom: '20px', alignSelf: 'flex-start' }}>
            {["All", ...new Set(dynamicQuotes.map(q => q.category).filter(Boolean))].map(cat => (
              <span
                key={cat}
                onClick={() => {
                  setActiveCategory(cat);
                  setCurrentQuoteIndex(0);
                }}
                className={activeCategory === cat ? "nav-item nav-item-active" : "nav-item"}
                style={activeCategory === cat ? { background: 'linear-gradient(90deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.1) 100%)', borderRadius: '40px' } : {}}
              >
                {cat.replace(/:\s*$/, '')}
              </span>
            ))}
          </div>

          {/* Quotes Display */}
          <div style={{ position: 'relative' }}>
             {isLoadingQuotes ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#777' }}>Loading quotes...</div>
             ) : (
                (() => {
                   const filtered = activeCategory === "All" ? dynamicQuotes : dynamicQuotes.filter(q => q.category === activeCategory);
                   if (filtered.length === 0) return <div style={{ textAlign: 'center', padding: '40px', color: '#777' }}>No quotes available in this category.</div>;
                   
                   const PREDEFINED_BGS = [
                     "https://picsum.photos/id/1015/800/800",
                     "https://picsum.photos/id/1016/800/800",
                     "https://picsum.photos/id/1018/800/800",
                     "https://picsum.photos/id/1019/800/800",
                     "https://picsum.photos/id/1020/800/800",
                     "https://picsum.photos/id/1021/800/800",
                     "https://picsum.photos/id/1022/800/800",
                     "https://picsum.photos/id/1023/800/800",
                     "https://picsum.photos/id/1024/800/800",
                     "https://picsum.photos/id/1025/800/800",
                   ];

                   const q = filtered[currentQuoteIndex];
                   if (!q) return null;

                   const bgImg = q.image || PREDEFINED_BGS[currentQuoteIndex % PREDEFINED_BGS.length];
                   
                   return (
                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', width: '100%' }}>
                       <button 
                         onClick={() => setCurrentQuoteIndex((prev) => (prev - 1 + filtered.length) % filtered.length)}
                         style={{ position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, background: 'rgba(255,255,255,0.3)', color: 'white', border: 'none', borderRadius: '50%', width: '50px', height: '50px', cursor: 'pointer', fontSize: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(5px)' }}
                       >
                         ‹
                       </button>
                       <AnimatePresence mode="wait">
                         <motion.div 
                            key={currentQuoteIndex}
                            initial={{ rotateX: -90, opacity: 0 }}
                            animate={{ rotateX: 0, opacity: 1 }}
                            exit={{ rotateX: 90, opacity: 0 }}
                            transition={{ duration: 0.6, type: "spring", bounce: 0.3 }}
                            style={{ 
                              position: 'relative', 
                              borderRadius: '24px', 
                              overflow: 'hidden', 
                              minHeight: '450px',
                              width: '100%',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              padding: '40px 20px',
                              boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                              marginBottom: '20px'
                           }}>
                              {/* Background */}
                              <img src={bgImg} alt="bg" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,48,73,0.6)' }} />
                              
                              {/* Content */}
                              <h3 style={{ position: 'relative', color: 'white', textAlign: 'center', fontSize: '24px', fontWeight: '400', lineHeight: '1.5', zIndex: 2, margin: '0 0 20px 0', fontFamily: "'Syne', sans-serif" }}>
                                 {q.text}
                              </h3>
                              {q.author && (
                                 <p style={{ position: 'relative', color: '#FFEBD9', textAlign: 'center', fontSize: '16px', zIndex: 2, margin: 0 }}>
                                    - {q.author}
                                 </p>
                              )}
                         </motion.div>
                       </AnimatePresence>
                       <button 
                         onClick={() => setCurrentQuoteIndex((prev) => (prev + 1) % filtered.length)}
                         style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, background: 'rgba(255,255,255,0.3)', color: 'white', border: 'none', borderRadius: '50%', width: '50px', height: '50px', cursor: 'pointer', fontSize: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(5px)' }}
                       >
                         ›
                       </button>
                     </div>
                   )
                })()
             )}
          </div>
        </div>
      </section>

      {/* 3. FOUR CARDS SECTION */}
      <section className="cards-section">
        <div className="card-grid">

          {/* The Action Card */}
          <div className="info-card hover-card"
            onClick={handleConnect}
          >
            <div className="logo-tooltip-wrapper">
              <div className="flip-logo-inner">
                <div className="flip-logo-front">
                  <img
                    src="/Nabi UI Assets/Assets_Images/Logo placeholder.png"
                    alt="logo"
                    className="card-top-logo-img"
                  />
                </div>
                <div className="flip-logo-back">
                  <span className="safe-start-flip-text">A safe start<br/>matters</span>
                </div>
              </div>
              <span className="tooltip-text">Your first 40 minute session is on us because trust comes before therapy</span>
            </div>
            <a className="connect-with-psych-title" style={{ textDecoration: 'underline', cursor: 'pointer', marginTop: '15px' }}>
              Connect with a Psychologist
            </a>
            <p className="card-text">
              When you believe it helps, reach out to a psychologist; find professional help with ease.
            </p>
          </div>

          <div 
            className="info-card hover-card"
            onClick={() => navigate('/selfreflection')}
            style={{ cursor: 'pointer' }}
          >
            <img
              src="/Nabi UI Assets/Assets_Images/Logo placeholder.png"
              alt="logo"
              className="card-top-logo"
            />
            <InfoCard
              title="Reflections"
              text="Sometimes the answers we seek are within us. Reflect, introspect and understand who you truly are"
              isLink={true}
            />
          </div>

          <div className="info-card">
            <img
              src="/Nabi UI Assets/Assets_Images/Logo placeholder.png"
              alt="logo"
              className="card-top-logo"
            />
            <InfoCard
              title="Better Together"
              text=" Coming Soon..."
            />
          </div>

        </div>
      </section>

      {/* 4. COMMUNITY SECTION (Dark Blue) */}
      {/* <section style={styles.communitySection}>
         <h2 style={styles.communityTitle}>Nabi Community</h2>
         <p style={styles.communityText}>
           Our purpose is to create a community where people feel safe to explore and talk about their emotions because, when we understand ourselves better, we do better and that creates a positive effect within oneself and on others.
         </p>
      </section> */}

      {/* 5. SLIDER SECTION (Orange) */}
      {/* <section style={styles.sliderSection}>
          <div style={styles.sliderContainer}>
              <button onClick={prevSlide} style={styles.arrowBtn}>‹</button>
              
              <motion.div 
                key={currentSlide}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
                style={styles.slideCard}
              >
                <h3 style={styles.slideTitle}>{slides[currentSlide].title}</h3>
                <p style={styles.slideText}>{slides[currentSlide].text}</p>
              </motion.div>

              <button onClick={nextSlide} style={styles.arrowBtn}>›</button>
          </div>
          <div style={styles.dotsContainer}>
              {slides.map((_, idx) => (
                  <div key={idx} style={{...styles.dot, backgroundColor: idx === currentSlide ? '#333' : 'rgba(0,0,0,0.2)'}} />
              ))}
          </div>
        </section> */}

      {/* 6. HELPLINE RESOURCES */}
      {/* <section style={styles.helplineSection}>
         <h2 style={styles.helplineTitle}>Helpline: Resources</h2>
         <p style={styles.helplineSub}>Sometimes, a little extra support is necessary: and we get it. You can find below a few helpline resources to access and turn to for further, immediate assistance. Support might start with Nabi for you, but it doesn't end here.</p>
         
         <div style={styles.resourceGrid}>
            <div style={styles.resourceCard}>
               <h3 style={styles.resCardTitle}>Counselling</h3>
               <p style={styles.resCardText}>Tele-counselling, crisis, and suicide prevention lines.</p>
               <a href="tel:18008914416" style={{ ...styles.resButton, display: 'inline-block', textDecoration: 'none', color: '#003049', textAlign: 'center' }}>Click Here</a>
            </div>
            <div style={styles.resourceCard}>
               <h3 style={styles.resCardTitle}>Women in Distress</h3>
               <p style={styles.resCardText}>Distress, domestic abuse or mistreatment, and support lines.</p>
               <a href="tel:181" style={{ ...styles.resButton, display: 'inline-block', textDecoration: 'none', color: '#003049', textAlign: 'center' }}>Click Here</a>
            </div>
         </div>
      </section> */}

    </div>
  );
}

function InfoCard({ title, text, isLink }) {
  return (
    <>
      {isLink ? (
        <a className="connect-with-psych-title" style={{ textDecoration: 'underline', cursor: 'pointer', display: 'block', marginTop: '15px' }}>{title}</a>
      ) : (
        <h3 className="card-title">{title}</h3>
      )}
      <p className="card-text">{text}</p>
    </>
  )
}
